import * as en_US from '@translations/en-US.json';
import * as en_GB from '@translations/en-GB.json';
import * as es_ES from '@translations/es-ES.json';

const locales = {
  'en-US': en_US,
  'en-GB': en_GB,
  'es-ES': es_ES,
};

export default locales;
